import Vue from 'vue'
const MYStorage = new Vue({
  data () {
    return {
      categories: [],
      catNames: [],
      status: [],
      currencySymbol: '€',
      currencyFormat: 'de-DE',
      currencyFixed: 2,
      catObjectsByGuid: [],
      statusObjectsByGuid: [],
      statusList: [],
      callBackOnGetStatus: null,
      callBackOnGetCategories: null
    }
  },
  methods: {
    loadCategories (callback, onError) {
      this.callBackOnGetCategories = callback
      // Vue.prototype.$dms.getStorageCategories(this.onGetCategories, onError)
      // Vue.prototype.scanApi.getCategories(this.onGetCategories, onError)
    },
    loadStatus (callback) {
      this.callBackOnGetStatus = callback
      Vue.prototype.$dms.getStorageStatus(this.onGetStatus)
    },
    getCategories () {
      console.log('categories', this.categories)
      return this.categories
    },
    getStatusObjectGuidList () {
      console.log('statusObjectsByGuid', this.statusObjectsByGuid)
      return this.statusObjectsByGuid
    },
    getStatusList () {
      console.log('getStatusList', this.statusList)
      return this.statusList
    },
    getCategoriesObjectGuidList () {
      return this.catObjectsByGuid
    },
    getCategoriesNamesList () {
      return this.catNames
    },
    onGetStatus (data) {
      this.status = data.status
      this.statusList = []
      this.statusObjectsByGuid = {}
      for (var i in data.status) {
        var cat = data.status[i]
        try {
          cat.config = JSON.parse(cat.config)
        } catch (e) {

        }
        this.statusObjectsByGuid[cat.guid] = cat
        this.statusList.push(cat)
      }
      if (this.callBackOnGetStatus) {
        this.callBackOnGetStatus(data)
      }
      console.log('statusObjectsByGuid', this.statusObjectsByGuid, this.statusList)
    },
    onGetCategories (data) {
      this.categories = data.categories
      for (var i in data.categories) {
        var cat = data.categories[i]
        this.catNames[cat.guid] = cat.title
        this.catObjectsByGuid[cat.guid] = cat
        try {
          cat.extraFields = JSON.parse(cat.extraFields)
        } catch (e) {
          console.log(e)
        }
      }
      if (this.callBackOnGetCategories) {
        this.callBackOnGetCategories(data)
      }
    },
    checkExtraFieldStatus (item) {
      if (item.extraFields && typeof item.extraFields === 'string') {
        item.extraFields = JSON.parse(item.extraFields)
      } else if (item.extraFields && typeof item.extraFields === 'object') {
        // do nothing here
      } else {
        item.extraFields = {}
      }
      if (typeof item.extraFields === 'string') {
        item.extraFields = {}
      }
      return item
    },
    formatStringToCurrency (value) {
      let maximumFractionDigits = this.currencyFixed
      let minimumFractionDigits = this.currencyFixed
      let vvv = (1 * value).toLocaleString(this.currencyFormat, {
        style: 'decimal',
        useGrouping: true,
        maximumFractionDigits: maximumFractionDigits,
        minimumFractionDigits: minimumFractionDigits
      })
      return vvv
    }
  }}
)
export default MYStorage



// WEBPACK FOOTER //
// ./src/storage.js